import { useAppDispatch, useAppSelector } from 'app/hooks';
import AlertModal from 'components/common/AlertModal';
import Footer from 'components/common/Footer';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { NotFound } from 'components/common/NotFound';
import BusinessTypeFeature from 'features/BusinessType';
import { editModeActions, selectIsEditModeErrorOpen } from 'features/common/editModeSlice';
import CounterPatternFeature from 'features/CounterPattern';
import DeliveryFeature from 'features/Delivery';
import DemoFeature from 'features/Demo';
import ImportDataFeature from 'features/ImportData';
import MenuBookFeature from 'features/MenuBook';
import SaleTypeFeature from 'features/SaleType';
import StoreFeature from 'features/Store';
import useDetectEditMode from 'hooks/useDetectEditMode';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';
import { history } from 'utils';
// import { PERMISSIONS } from 'utils';

export const ROUTE_PERMISSION_MAPPING: { [key: string]: string } = {
  // '/inventory': PERMISSIONS.INVENTORY,
  // '/inspection': PERMISSIONS.INSPECTION,
  // '/asset': PERMISSIONS.SEARCH_ASSET,
  // '/inventory-history': PERMISSIONS.INVENTORY_HISTORY,
  // '/movement-history': PERMISSIONS.MOVEMENT_HISTORY,
  // '/asset-model': PERMISSIONS.ASSET_MODEL,
  // '/asset/add': PERMISSIONS.ASSET_DETAIL,
  // '/asset/edit/:id': PERMISSIONS.ASSET_DETAIL,
  // '/inspection-history': PERMISSIONS.INSPECTION_HISTORY,
  // '/admin-master': PERMISSIONS.ADMIN_MASTER,
};

export function AppLayout() {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const dispatch = useAppDispatch();

  // selectors
  const isEditModeErrorOpen = useAppSelector(selectIsEditModeErrorOpen);

  useDetectEditMode();

  useEffect(() => {
    if (isEditModeErrorOpen) {
      showGlobalModal(() => (
        <AlertModal
          title={t('App.warning')}
          message="指定された配信Noの再編集は、削除されたか承認が完了されたため動作しません。配信一覧／状況一覧をご確認ください。"
          onClose={() => {
            dispatch(editModeActions.disableEditMode());
            dispatch(editModeActions.closeEditModeError());
            history.push('/delivery/delivery-setting', { replace: true });
          }}
        />
      ));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditModeErrorOpen]);

  return (
    <>
      <section className="main-content">
        <Switch>
          <Route exact path="/">
            <Redirect to="/delivery/delivery-setting" />
          </Route>
          <Route path="/demo">
            <DemoFeature />
          </Route>
          <Route path="/business-type">
            <BusinessTypeFeature />
          </Route>

          <Route path="/store">
            <StoreFeature />
          </Route>
          <Route path="/counter-pattern">
            <CounterPatternFeature />
          </Route>
          <Route path="/sale-type">
            <SaleTypeFeature />
          </Route>
          <Route path="/menu-book">
            <MenuBookFeature />
          </Route>
          <Route path="/delivery">
            <DeliveryFeature />
          </Route>
          <Route path="/data-setting">
            <ImportDataFeature />
          </Route>
          <Route path="/404">
            <NotFound />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
        <div className="page-footer">
          <Footer />
        </div>
      </section>
    </>
  );
}
